module.exports = __webpack_public_path__ + "img/img_17.0e8706ee.jpg";